const isOverlappingRange = (filterValue, candidate) => {
  if (
    candidate.min === null ||
    candidate.max === null ||
    Number.isNaN(+candidate.min) ||
    Number.isNaN(+candidate.max)
  ) {
    return false;
  }

  return (
    (filterValue.min <= candidate.min && // fccf
      candidate.max <= filterValue.max) ||
    (candidate.min <= filterValue.min && // cfcf
      filterValue.min <= candidate.max &&
      candidate.max <= filterValue.max) ||
    (candidate.min <= filterValue.min && // cffc
      filterValue.max <= candidate.max) ||
    (filterValue.min <= candidate.min && // fcfc
      candidate.min <= filterValue.max &&
      filterValue.max <= candidate.max)
  );
};

// include above and below allow us to specify a range that is smaller than the actual values.
// EX: you want to include a few high outliers but they mess up the filter. Set includeAbove to true
const isInRange = (
  filterValue,
  filterLimits,
  candidate,
  includeAbove = false,
  includeBelow = false,
) => {
  if (candidate === null || Number.isNaN(+candidate)) {
    return false;
  }

  const min =
    includeBelow && filterValue.min <= filterLimits.min ? Number.MIN_SAFE_INTEGER : filterValue.min;

  const max =
    includeAbove && filterValue.max >= filterLimits.max ? Number.MAX_SAFE_INTEGER : filterValue.max;

  return min <= candidate && candidate <= max;
};

const addIfTrue = (predicates, condition, predicate) => {
  if (condition) {
    predicates.push(predicate);
  }
};

const filterByPredicates = (list, predicates) => {
  if (!Array.isArray(list)) {
    return null;
  }

  const combinedPredicate = d => {
    const allTrue = predicates.every(p => p(d));
    return allTrue;
  };

  return list.filter(combinedPredicate);
};

export { addIfTrue, filterByPredicates, isInRange, isOverlappingRange };



// WEBPACK FOOTER //
// ./src/App/Predicates.js